module.exports = __webpack_public_path__ + "static/media/settings_gear.51c6ebf8.svg";